// src/hooks/programs/useCreateProgram.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createProgram } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreateProgram = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createProgramMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createProgram,
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/programs');
            queryClient.invalidateQueries({ queryKey: ["programs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create program");
        },
    });

    return {
        createProgramMutate,
        isPending: isPending || isLoading,
    };
};

export default useCreateProgram;
